import { render, staticRenderFns } from "./ModalBemVindos.vue?vue&type=template&id=39bb2b7a&scoped=true&"
import script from "./ModalBemVindos.vue?vue&type=script&lang=js&"
export * from "./ModalBemVindos.vue?vue&type=script&lang=js&"
import style0 from "./ModalBemVindos.vue?vue&type=style&index=0&id=39bb2b7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb2b7a",
  null
  
)

export default component.exports